"use client";

import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function CreateAccountModal({ children }: { children: React.ReactNode }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Create Virtual Account</DialogTitle>
          <DialogDescription>
            Assign a new dedicated virtual account to a customer.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="customer">Customer Email</Label>
            <Input id="customer" type="email" placeholder="customer@example.com" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="customerName">Customer Name</Label>
            <Input id="customerName" placeholder="John Doe" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="bank">Preferred Bank</Label>
            <select id="bank" className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm">
              <option>Wema Bank</option>
              <option>Providus Bank</option>
              <option>Sterling Bank</option>
            </select>
          </div>
          <Button className="w-full mt-4">Generate Account</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
